import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb, Tabs, TabsProps } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { IconCashRegisterSolid } from "../../../../icon";
import styled from "styled-components";
import { useCallback, useEffect, useMemo, useState } from "react";
import SettlementEmployeeClosure from "./settlement-employee-closure";
import SettlementCustomerTimesheets from "./settlement-customer-timesheets";
import SettlementCustomerInvoices from "./settlement-customer-invoices";
import SettlementBookings from "./settlement-bookings";
import dayjs from "dayjs";

const TabsStyled = styled(Tabs)`
  flex: 1;

  .ant-tabs-content, .ant-tabs-tabpane {
    height: 100%;
  }
`

function SettlementPage() {
  const { subpage } = useParams();

  const savedFilterJSON = sessionStorage.getItem('settlementFilter');
  const savedFilter = useMemo(() => {
    const result = savedFilterJSON ? JSON.parse(savedFilterJSON) : {};
    if(result?.month) {
      result.month = dayjs(result.month);
    }
    return result;
  }, [savedFilterJSON]);

  const [filter, setFilter] = useState<any>(savedFilter || {});

  const setAndSaveFilter = useCallback((newFilter: any) => {
    setFilter(newFilter);
    sessionStorage.setItem('settlementFilter', JSON.stringify(newFilter));
  }, [setFilter]);
  
  const navigate = useNavigate();

  useEffect(() => {
    if(!subpage) {
      navigate('/settlement/employee-closure', { replace: true })
    }
  }, [subpage, navigate])
 
  const tabItems: TabsProps['items'] = [
    {
      key: 'employee-closure',
      label: 'Mitarbeiter',
      children: <SettlementEmployeeClosure filter={filter} setFilter={setAndSaveFilter} />,
    },
    {
      key: 'timesheets',
      label: 'Leistungsnachweise Kunden',
      children: <SettlementCustomerTimesheets filter={filter} setFilter={setAndSaveFilter} />,
    },
    {
      key: 'invoice',
      label: 'Rechnungen Kunden',
      children: <SettlementCustomerInvoices filter={filter} setFilter={setAndSaveFilter} />,
    },
    {
      key: 'bookings',
      label: 'Buchungen',
      children: <SettlementBookings filter={filter} setFilter={setAndSaveFilter} />,
    },
  ];

  return (
    <div  style={{ height: "100%", overflow: "scroll", display: 'flex', flexDirection: 'column' }}>
       <Breadcrumb
          style={{ marginBottom: "24px" }}
          items={[
            {
              onClick: () => navigate('/'),
              title: <HomeOutlined />,
            },
            {
              onClick: () => navigate('/employee'),
              title: (
                <>
                  <IconCashRegisterSolid />
                  <span>Abrechnung</span>
                </>
              ),
            },         
          ]}
        />
      
        <TabsStyled items={tabItems} activeKey={subpage} onChange={newSubpage => navigate(`/settlement/${newSubpage}`)} />
    </div>
  )
}

export default SettlementPage;